import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: fixed;
  bottom: -1px;
  right: -1px;
  z-index: 1000;

  background: ${ColorPalette.HEX.BrightGray9};
  border: 1px solid ${ColorPalette.HEX.LightSilver};
  opacity: 0.8;

  padding: 2px;

  cursor: pointer;

  * > td {
    font-size: 8px;

    &:first-child {
      text-align: left;
      font-weight: bold;
      padding-right: 2px;
    }

    &:last-child {
      text-align: right;
    }
  }
`;
